import DefaultPinImage from '../assets/markers/pins/pin-empty@3x.png';
import BatteryPinImage from '../assets/markers/pins/pin-battery@3x.png';
import CriticalBatteryPinImage from '../assets/markers/pins/pin-battery-red@3x.png';
import GpsPinImage from '../assets/markers/pins/pin-gps@3x.png';
import SmcPinImage from '../assets/markers/pins/pin-smc@3x.png';
import BlePinImage from '../assets/markers/pins/pin-ble@3x.png';
import LockPinImage from '../assets/markers/pins/pin-lock@3x.png';

export const DefaultPin = {
  labelOrigin: { x: 37, y: 34 },
  scaledSize: { width: 74, height: 80 },
  url: DefaultPinImage,
  color: '#F18E00',
};

export const BatteryPin = {
  labelOrigin: { x: 37, y: 34 },
  scaledSize: { width: 74, height: 80 },
  url: BatteryPinImage,
  color: '#F18E00',
};

export const CriticalBatteryPin = {
  labelOrigin: { x: 37, y: 34 },
  scaledSize: { width: 74, height: 80 },
  url: CriticalBatteryPinImage,
  color: '#DB0000',
};

export const GpsPin = {
  labelOrigin: { x: 37, y: 34 },
  scaledSize: { width: 74, height: 80 },
  url: GpsPinImage,
  color: '#F18E00',
};

export const SmcPin = {
  labelOrigin: { x: 37, y: 34 },
  scaledSize: { width: 74, height: 80 },
  url: SmcPinImage,
  color: '#DB0000',
};

export const BlePin = {
	labelOrigin: { x: 37, y: 34 },
	scaledSize: { width: 74, height: 80 },
	url: BlePinImage,
	color: '#3497FD',
};

export const LockPin = {
  labelOrigin: { x: 37, y: 34 },
  scaledSize: { width: 74, height: 80 },
  url: LockPinImage,
  color: '#F18E00',
};
